import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './index.module.sass';

//Components
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Slide from '@mui/material/Slide';
import SectionTitle from '../../SectionTitle';

//Dependencies
import superagent from 'superagent';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='down' ref={ref} {...props} />;
});

const thisDate = new Date();

const Calendar = (props) => {
  const { device, webservice, getCookie } = props;
  const { screenSize } = device;
  const { t } = useTranslation(['calendar', 'global']);
  const [calendar, setCalendar] = useState([]);
  const [meetings, setMeetings] = useState([]);
  const [trainings, setTrainings] = useState([]);
  const [optionSelected, setOptionSelected] = useState('MEETINGS');
  const [eventSelected, setEventSelected] = useState([]);
  const [open, setOpen] = useState(false);

  const months = t('global:months', { returnObjects: true });
  const shortenedWeek = t('global:shortenedWeek', { returnObjects: true });

  const getDaysInMonth = (month, year) => {
    return new Date(year, month, 0).getDate();
  };

  const createCalendar = useCallback(() => {
    const daysInMonth = getDaysInMonth(thisDate.getMonth() + 1, thisDate.getFullYear());

    let calendar = [];
    for (let i = 0; i < daysInMonth; i++) {
      if (i === 0) {
        const fistDay = new Date(thisDate.getFullYear(), thisDate.getMonth());
        for (let h = 0; h < fistDay.getDay(); h++) {
          calendar.push({ day: 0 });
        }
        calendar.push({ day: i + 1 });
      } else calendar.push({ day: i + 1 });
    }

    setCalendar(calendar);
  }, []);

  const showEvent = (event) => {
    if (event.length > 0) {
      setEventSelected(event);
      setOpen(true);
    } else return;
  };

  const getEvents = useCallback(() => {
    const date = new Date();
    const token = getCookie('TMBAccesToken');

    superagent
      .get(`${webservice}/getCalendario?mes=${date.getMonth() + 1}&anio=${date.getFullYear()}`)
      // .get(
      //   `https://api.terramarbrands.com.mx/calendar?mes=${
      //     date.getMonth() + 1
      //   }&anio=${date.getFullYear()}`,
      // )
      .set('Content-Type', 'application/json')
      .set('Authorization', token)
      .then((res) => {
        const { body = {} } = res;
        const { tipoMensaje = 'error', eventos = [] } = body;

        if (tipoMensaje !== 'exito') alert('No hay eventos');
        else {
          let meetingsArray = [];
          let trainingsArray = [];

          const monthDays = getDaysInMonth(date.getMonth() + 1, date.getFullYear());

          for (let i = 0; i < monthDays; i++) {
            meetingsArray[i] = [];
            trainingsArray[i] = [];

            eventos.map(function (val, key) {
              if (val.tipo === 'CAPACITACION' && parseInt(val.dia) - 1 === i) {
                trainingsArray[i].push(val);
              } else if (parseInt(val.dia) - 1 === i) {
                meetingsArray[i].push(val);
              }

              return null;
            });
          }

          setMeetings(meetingsArray);
          setTrainings(trainingsArray);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [getCookie, webservice]);

  useEffect(() => {
    createCalendar();
    getEvents();
  }, [createCalendar, getEvents]);

  return (
    <div id={styles.Calendar} className={`${styles[screenSize]} ${styles.calendar}`}>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setOpen(false)}
        aria-labelledby='alert-dialog-slide-title'
        aria-describedby='alert-dialog-slide-description'>
        <DialogContent className={styles.advertisementsContent}>
          <div className={styles.adverTitle}>{t('dialogTitle')}</div>
          <div className={styles.titles}>
            <div className={styles.description}>{t('description')}</div>
            <div className={styles.place}>{t('place')}</div>
          </div>
          {eventSelected.map((val, key) => {
            const { lugar, hora, evento, estado } = val;
            return (
              <div className={styles.event} key={key}>
                <div className={styles.eventDescription}>
                  <div className={styles.eventType}>{evento}</div>
                  <div className={styles.direction}>
                    {lugar} - {hora}
                  </div>
                </div>
                <div className={styles.place}>{estado}</div>
              </div>
            );
          })}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} color='primary'>
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      <SectionTitle
        title={(optionSelected === 'MEETINGS' && t('meetingButton')) || t('trainingButton')}
        subtitle={`${months[thisDate.getMonth()]} ${thisDate.getFullYear()}`}
      />

      <div className={styles.container}>
        <div className={styles.calendarContainer}>
          <div className={styles.week}>
            {shortenedWeek.map((val, key) => {
              return (
                <div className={styles.weekDay} key={key}>
                  {val}
                </div>
              );
            })}
          </div>
          {calendar.map((val, key) => {
            const { day } = val;
            if (optionSelected === 'MEETINGS') {
              return (
                <div
                  onClick={() => showEvent((day - 1 >= 0 && meetings[day - 1]) || [])}
                  key={key}
                  className={`${styles.monthDay}`}>
                  <div
                    className={`${styles.monthDate} ${
                      (day === 0 && styles.false) ||
                      (day - 1 >= 0 &&
                        meetings[day - 1] &&
                        meetings[day - 1].length > 0 &&
                        ((meetings[day - 1][0].tipo === 'NOLABORES' && styles.nolab) ||
                          styles.meeting))
                    }`}>
                    {(day !== 0 && day) || ''}
                  </div>
                </div>
              );
            } else if (optionSelected === 'TRAINING') {
              return (
                <div
                  onClick={() => showEvent((day - 1 >= 0 && trainings[day - 1]) || [])}
                  key={key}
                  className={`${styles.monthDay} `}>
                  <div
                    className={`${styles.monthDate} ${
                      (day === 0 && styles.false) ||
                      (day - 1 >= 0 &&
                        trainings[day - 1] &&
                        trainings[day - 1].length > 0 &&
                        styles.training)
                    }`}>
                    {(day !== 0 && day) || ''}
                  </div>
                </div>
              );
            }

            return null;
          })}
        </div>
        <div className={styles.actions}>
          <div className={styles.buttons}>
            <Button
              type='submit'
              variant='contained'
              size='large'
              color='primary'
              className={`${styles.button} ${styles[optionSelected === 'MEETINGS']} ${
                styles.selectButton
              }`}
              onClick={(e) => setOptionSelected('MEETINGS')}>
              <span className={`material-icons-outlined ${styles.buttonIcon}`}>groups</span>
              {t('meetingButton')}
            </Button>
            <Button
              type='submit'
              variant='contained'
              size='large'
              color='primary'
              className={`${styles.button} ${styles.lastButton} ${
                styles[optionSelected === 'TRAINING']
              } ${styles.selectButton}`}
              onClick={(e) => setOptionSelected('TRAINING')}>
              <span className={`material-icons-outlined ${styles.buttonIcon}`}>school</span>
              {t('trainingButton')}
            </Button>
          </div>
          {screenSize === 'desktop' && (
            <div className={styles.instructions}>
              {optionSelected === 'TRAINING' && (
                <div className={styles.instruccion}>
                  <div className={`${styles.recuadro} ${styles.azul}`}></div>
                  <div className={styles.recuardoTitle}>{t('trainingButton')}</div>
                </div>
              )}
              {optionSelected === 'MEETINGS' && (
                <div className={styles.instruccion}>
                  <div className={`${styles.recuadro} ${styles.rosa}`}></div>
                  <div className={styles.recuardoTitle}>{t('meetingButton')}</div>
                </div>
              )}
              <div className={styles.instruccion}>
                <div className={styles.recuadro}></div>
                <div className={styles.recuardoTitle}>{t('noEvent')}</div>
              </div>
              {optionSelected === 'MEETINGS' && (
                <div className={styles.instruccion}>
                  <div className={`${styles.recuadro} ${styles.nolab}`}></div>
                  <div className={styles.recuardoTitle}>{t('doNotWork')}</div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Calendar;
